import { useState, useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Button, Form, Spinner, Alert } from "react-bootstrap";
import { BrowserContext } from "./services/BrowserContext";

const LoginPage = ({ authStatus }) => {
    const { itemsManipulator } = useContext(BrowserContext);
    const location = useLocation();

    const [name, setName] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    // Déjà connecté → on repart vers la destination initiale (ou la racine).
    if (authStatus === 'authed') {
        return <Navigate to={location.state?.from || '/root/'} replace />;
    }

    // Vérification de session en cours au démarrage : évite le flash du formulaire.
    if (authStatus === 'checking') {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
                <Spinner animation="border" variant="secondary" />
            </div>
        );
    }

    const submit = (e) => {
        e.preventDefault();
        if (submitting) return;
        setError(false);
        setSubmitting(true);
        itemsManipulator.login(name, password, (ok) => {
            setSubmitting(false);
            if (!ok) setError(true);
        });
    };

    return (
        <div className="d-flex justify-content-center align-items-center bg-light" style={{ minHeight: '100vh' }}>
            <div className="card shadow-sm border-0" style={{ width: '100%', maxWidth: '400px' }}>
                <div className="card-body p-4">
                    <h1 className="h4 text-center mb-4">
                        <i className="bi bi-hdd me-2"></i>ClodoDrive
                    </h1>
                    {error && <Alert variant="danger" className="py-2">Identifiants incorrects</Alert>}
                    <Form onSubmit={submit}>
                        <Form.Group className="mb-3">
                            <Form.Label htmlFor="username">Nom d'utilisateur</Form.Label>
                            <Form.Control
                                id="username"
                                value={name}
                                onChange={e => setName(e.target.value)}
                                autoFocus
                                autoComplete="username"
                            />
                        </Form.Group>
                        <Form.Group className="mb-4">
                            <Form.Label htmlFor="password">Mot de passe</Form.Label>
                            <Form.Control
                                id="password"
                                type="password"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                autoComplete="current-password"
                            />
                        </Form.Group>
                        <Button variant="primary" type="submit" className="w-100" disabled={submitting}>
                            {submitting
                                ? <Spinner animation="border" size="sm" />
                                : <><i className="bi bi-box-arrow-in-right me-2"></i>Se connecter</>
                            }
                        </Button>
                    </Form>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
